import { XMLParser } from "fast-xml-parser";

export function parseXml(data) {
  try {
    const parser = new XMLParser({ ignoreAttributes: false });
    return parser.parse(data);
  } catch (error) {
    console.error("XML parsing error:", error);
    throw error;
  }
}
